import banner from "../../../courses/module-2/img6.png";

const modulo6 = {
  courseId: "cripto-blockchain",
  id: "modulo-6",
  title: "🧩 MÓDULO 6: DeFi, NFTs y otras palabras raras",
  estimatedDuration: "1 hora 30 minutos",
  format: "Lectura + actividad práctica",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo del módulo",
      content: [
        "Comprender los conceptos más comunes (y confusos) que encontrarás al explorar el mundo Web3: qué es DeFi, para qué sirven los NFTs y qué significan términos como DAO, staking o farming.",
      ],
    },
    {
      id: "que-es-defi",
      navLabel: "¿Qué es DeFi?",
      title: "💬 ¿Qué es DeFi (Finanzas Descentralizadas)?",
      content: [
        {
          type: "paragraph",
          text: 'DeFi significa "Decentralized Finance" (finanzas descentralizadas) y se refiere a todo un ecosistema de aplicaciones financieras construidas sobre blockchain que no dependen de bancos, gobiernos ni intermediarios tradicionales.',
        },
        {
          type: "paragraph",
          text: "En vez de usar un banco para pedir un préstamo, ganar intereses o intercambiar monedas, lo haces directamente con otros usuarios mediante contratos inteligentes.",
        },
        {
          type: "paragraph",
          text: "📌 Ejemplos reales:",
        },
        {
          type: "list",
          items: [
            "Aave: plataforma donde puedes pedir préstamos en cripto o prestar tus fondos para ganar intereses.",
            "Uniswap: intercambias tokens sin necesidad de una casa de cambio tradicional.",
            "Compound: ganas intereses depositando tus criptomonedas.",
          ],
        },
        {
          type: "paragraph",
          text: "🧾 Palabra clave: Smart contract",
        },
        {
          type: "paragraph",
          text: "Son programas que se ejecutan automáticamente cuando se cumplen ciertas condiciones. Por ejemplo: “si Marcos deposita USDC, envíale 3% de interés anual”.",
        },
      ],
    },
    {
      id: "que-son-nfts",
      navLabel: "¿Qué son los NFTs?",
      title: "🎨 ¿Qué son los NFTs?",
      content: [
        {
          type: "paragraph",
          text: "NFT significa Non-Fungible Token. A diferencia de una criptomoneda como BTC (que puedes intercambiar por otra igual), un NFT es único, como una obra de arte digital.",
        },
        {
          type: "paragraph",
          text: "🎯 Características:",
        },
        {
          type: "list",
          items: [
            "Son certificados digitales de propiedad.",
            "Viven en la blockchain.",
            "Pueden representar arte, música, entradas, videojuegos, identidades digitales e incluso objetos físicos.",
          ],
        },
        {
          type: "paragraph",
          text: "📌 Ejemplos reales:",
        },
        {
          type: "list",
          items: [
            "NBA Top Shot: videos coleccionables oficiales de jugadas.",
            "Bored Ape Yacht Club: colección de artes digitales que se convirtieron en símbolos de estatus digital.",
            "Axie Infinity: juego donde cada criatura que uses es un NFT.",
          ],
        },
      ],
    },
    {
      id: "otros-conceptos",
      navLabel: "Otros conceptos",
      title: "🛠 Otros conceptos clave",
      content: [
        {
          type: "table",
          headers: ["Término", "¿Qué significa?", "Ejemplo real"],
          rows: [
            [
              "Staking",
              "Dejar tus criptos “bloqueadas” para validar la red y recibir recompensas.",
              "Hacer staking de ADA en Cardano y ganar 5% anual",
            ],
            [
              "DAO",
              "Organización autónoma gobernada por sus miembros con reglas en blockchain.",
              "Un colectivo de artistas que decide qué obras financiar",
            ],
            [
              "Airdrop",
              "Recompensa gratuita de tokens por participar en un proyecto o usar una app.",
              "Usaste una DApp y te regalaron tokens nuevos",
            ],
            [
              "Yield farming",
              "Mover tus fondos entre varias plataformas DeFi para maximizar tus ganancias.",
              "Depositar USDC en una app, sacar, mover a otra con más rendimiento",
            ],
          ],
        },
      ],
    },
    {
      id: "tabla-resumen",
      navLabel: "Resumen",
      title: "🧩 Tabla resumen – Conceptos clave de Web3",
      content: [
        {
          type: "table",
          headers: [
            "Término",
            "Definición simple",
            "Ejemplo real o comparación",
          ],
          rows: [
            [
              "DeFi",
              "Finanzas sin bancos",
              "Usar Uniswap en lugar de una casa de cambio",
            ],
            [
              "NFT",
              "Archivo digital único",
              "Un cuadro digital que sólo tú posees",
            ],
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recursos",
      title: "📌 Recursos recomendados",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/the-complete-beginners-guide-to-decentralized-finance-defi",
          text: "Binance Academy – DeFi explicado",
        },
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-is-an-nft",
          text: "Binance Academy – Qué es un NFT",
        },
        {
          type: "link",
          href: "https://www.coinbase.com/learn/nfts-daos-and-more",
          text: "Coinbase Learn – NFTs, DAOs y más",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "🎯 Actividad del módulo",
      content: [
        {
          type: "paragraph",
          text: "🧪 Desafío práctico – “Explorando el ecosistema Web3”",
        },
        {
          type: "paragraph",
          text: "1. Busca en internet un proyecto NFT o DeFi real (puede ser en español o inglés).",
        },
        {
          type: "paragraph",
          text: "2. Investiga:",
        },
        {
          type: "list",
          items: [
            "¿Qué problema soluciona?",
            "¿Qué red utiliza (Ethereum, Polygon, etc.)?",
            "¿Qué utilidad ofrece al usuario?",
          ],
        },
        {
          type: "paragraph",
          text: "3. Crea un documento de Google Docs con una descripción breve (5–8 líneas).",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: [
        "“El futuro pertenece a quienes entienden la tecnología… pero también a quienes saben usarla con propósito.”",
      ],
    },
  ],
};

export default modulo6;
